import { AxiosResponse } from "axios";

type APIError = AxiosResponse<{
  errors: string;
}>;

export function isAPIError(error: unknown): error is APIError {
  return !!(error && typeof error === "object" && "data" in error);
}
